import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import LoadingScreen from "../components/common/LoadingScreen";
import { writeAuthReturnLocation } from "../domain/auth/authReturnLocation";
import { playerNeedsOnboarding } from "../domain/identity/playerIdentityGate";
import { useMyPlayerProfile } from "../features/profile/hooks/useMyPlayerProfile";
import RequiredIdentityScreen from "../features/profile/components/RequiredIdentityScreen";
import { E2E_AUTH_STUB_ENABLED } from "./e2eAuthStub";

/**
 * Requires a non-anonymous Firebase session. Unauthenticated users go to `/sign-in`.
 * Remembers the current URL so post-auth (or a refresh on Welcome) returns here.
 */
export default function AuthGate() {
  const { isAuthenticated, loading, error } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <LoadingScreen
        variant="splash"
        message={error?.message || "Loading TheRallyAlly…"}
      />
    );
  }

  if (!isAuthenticated) {
    writeAuthReturnLocation(location);
    return <Navigate to="/sign-in" replace state={{ from: location }} />;
  }

  return <OnboardedOutlet />;
}

function OnboardedOutlet() {
  const { view, loading, saveProfile } = useMyPlayerProfile();

  if (loading && !view) {
    return <LoadingScreen variant="splash" message="Loading your player…" />;
  }

  if (!E2E_AUTH_STUB_ENABLED && view && playerNeedsOnboarding(view)) {
    return <RequiredIdentityScreen view={view} onSave={saveProfile} />;
  }

  return <Outlet />;
}
